import { render } from "./RoomBanner.vue?vue&type=template&id=479eda6a"
import script from "./RoomBanner.vue?vue&type=script&lang=js"
export * from "./RoomBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__